export const router = [
  {
    path: "project",
    component: (resolve) => require(["./Index.vue"], resolve),
  },
];
